import { transparentize } from 'polished';
import styled from 'styled-components';

import { standardFocusStyles } from '@main/pc-core-components';
import { layoutSizes, responsive, sp, timing } from '@main/theme';

/**
 * Wrapper contents
 */
export const WrapperContents = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-left: ${sp(2)};

  ${responsive.justTablet} {
    flex-grow: 0;
  }
`;

/**
 * Wrapper logo
 */
export const WrapperLogo = styled.a`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 2;
  width: fit-content;
  max-width: fit-content;
  height: 100%;
  border-radius: ${sp(0.5)};

  transition: all ${timing.short};
  &:hover {
    opacity: 0.7;
  }
  &:focus {
    ${standardFocusStyles}
  }

  ${responsive.atLeastTablet} {
    display: none;
  }
`;

/**
 * Logo image wrapper
 */
export const LogoImageWrapper = styled.img`
  width: auto;
  max-width: ${sp(18)};
  height: 100%;
  object-fit: scale-down;
`;

/**
 * Wrapper nav
 */
export const WrapperNav = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-right: ${sp(2)};

  ${responsive.atLeastTablet} {
    margin-left: ${sp(2)};
    margin-top: ${sp(0.6)};
  }
`;

/**
 * The Header container main wrapper
 */
export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.white};
  padding: ${sp(1.5)};

  ${responsive.beforeTablet} {
    height: 67px;
    padding: ${sp(1.5)} ${sp(3.25)};
    box-shadow: 0px 1px 6px
      ${({ theme }) => transparentize(0.8, theme.colors.black)};
  }

  ${responsive.atLeastTablet} {
    padding: 0 ${sp(1.5)} 0 0;
    border-radius: 14px 0 0 0;
  }

  ${responsive.atLeastDesktop} {
    padding: 0 ${layoutSizes.desktop.msp(0.5)};
  }
`;
